import { render } from "./ProfileElectedInfo.vue?vue&type=template&id=b3314d84&scoped=true"
import script from "./ProfileElectedInfo.vue?vue&type=script&lang=js"
export * from "./ProfileElectedInfo.vue?vue&type=script&lang=js"

import "./ProfileElectedInfo.vue?vue&type=style&index=0&id=b3314d84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3314d84"]])

export default __exports__